import React from 'react';
import {Field} from "formik";
import {makeStyles} from "@material-ui/core";
import Multiselectinput from '../../components/formikcomponent/MutiSelectinput';
const TopicTag  = (props) => {
  const useStyles = makeStyles(() => ({
    createUserSelect: {
      "& p": {
        maxWidth: "200px", textOverflow: "ellipsis",
        display: "inline-block", overflow: "hidden", whiteSpace: "nowrap !important",
      }
    }
  }));
const classes = useStyles();
return(
  <Field
    name="topictag"
    options={props.topictagoption}
    component={Multiselectinput}
    label="Topic Tag *"
    variant="filled"
    placeholder="Topic Tag "
    className={classes.createUserSelect + " " + "selectstyle"}
    menuPortalTarget={document.body}
    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
  />
);
};
export default TopicTag;